"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ECountryCOM = void 0;
const ECountry_1 = require("./ECountry");
exports.ECountryCOM = [
    ECountry_1.ECountry.polynesie_francaise,
    ECountry_1.ECountry.saint_pierre_et_miquelon,
    ECountry_1.ECountry.wallis_et_futuna,
    ECountry_1.ECountry.saint_barthelemy,
    ECountry_1.ECountry.saint_martin,
];
